import type { QueryKey } from '$lib/api/tanstack-query';

import type { ResourceType } from '$lib/permissions';
import { locationKeys } from '../locations/query-key';

const BASE = ['permission'] as const;

export const permissionKeys = {
  all: () => [...BASE] as const,
  get: (
    resourceType: ResourceType | undefined,
    resourceID: string | undefined
  ): QueryKey => [...BASE, { resourceType, resourceID }] as const,
  authorizations: (organizationID: string | undefined) =>
    [...BASE, 'authorizations', { organizationID }] as const,
};

/**
 *  Returns queries to invalidate given the input parameters for mutations that update roles/authorizations
 *  @param identityID the user ID of the role(s) updated
 *  @param orgID the organization of the role(s) updated
 *  @param resourceID the resource ID of the role(s) updated
 *  @param appUserID the user ID of the current app user
 *  @returns a list of query keys to invalidate
 */
export const getInvalidatedQueriesForRoleMutations = (
  identityID: string,
  orgID: string,
  resourceID: string,
  appUserID: string
): QueryKey[] => {
  return [
    identityID === appUserID
      ? permissionKeys.all()
      : permissionKeys.authorizations(orgID),
    ['listKeys', orgID],
    locationKeys.listLocKeys(resourceID),
  ];
};
